import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSustainability = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 41 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M20.396 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m10.396 28-7 7h34l-7-7z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m9.396 22.536.707.707 3.536-3.536-.707-.707zM31.639 22.536l-.707.707-3.536-3.536.707-.707zM31.396 32.5v1h-18v-1zM19.396 29.5v1h-12v-1zM19.896 22.121h1V27h-1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSustainability);

export default ForwardRef;
